// You can use this key for drop confirm modal on navigate
// Example: navigate(deleteParamsFromUrl(['test']), { state: { [IGNORE_EDITABLE_AREA_PROMPT_KEY]: true } })
export const IGNORE_EDITABLE_AREA_PROMPT_KEY = 'ignorePrompt'